/* globals $ Craft */

export default class CareerOpportunities {
  constructor($elem) {
    this.$elem = $elem;
    this.$form = $elem.find("form");
    this.init();
  }

  init() {
    this.$form.submit((e) => {
      e.preventDefault();
      this.filter();
    });

    this.$form.find("select, input").change(() => {
      this.filter();
    });
  }

  filter() {
    let data = this.$form.serialize();
    if ($("#search_form_job").length) {
      data += "&keyword=" + $("#search_form_job input").val();
    }
    $.ajax({
      url: Craft.currentSite.baseUrl + "ajax/career-filter",
      data: data,
    }).done((data) => {
      this.$elem.find(".job_list").html(data);
    });
  }
}
